import { createAsyncThunk } from "@reduxjs/toolkit";
import { TServiceError } from "types/general";
import { apiClient } from "lib/apiClient";
import { COMPETITORS_SLICE_NAME } from "./constants";
import { ICompetitor } from "./types";

export const getCompetitors = createAsyncThunk<
  ICompetitor[],
  string,
  { rejectValue: TServiceError }
>(
  `${COMPETITORS_SLICE_NAME}/getCompetitors`,
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await apiClient.get<ICompetitor[]>(
        `/property/${id}/asset-dashboard/competitive-analysis`
      );

      return data;
    } catch (error) {
      return rejectWithValue({
        code: error.code,
        message: error.response?.data?.message ?? error.message,
      });
    }
  }
);
